// The checkbox's native `required` attribute is what blocks checkout while it's
// unchecked; this only swaps the browser's own validation text for the shop's
// Estonian message. `invalid` doesn't bubble, so it's captured on the document,
// which also covers the checkbox being re-rendered with the cart drawer/page.
const SELECTOR = '.cart-terms .checkbox__input';

document.addEventListener(
  'invalid',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(SELECTOR)) return;
    input.setCustomValidity(input.dataset.requiredMessage ?? '');
  },
  true
);

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(SELECTOR)) return;
  input.setCustomValidity('');
});
